import PrinterModule from '~/lib/vue/modules/document/printer';

export default (services, namespace='printer') => {
  return PrinterModule.create({
    namespace,
    services,
  });
};
